import { Fragment, useMemo } from 'react';
import { ChildrenPropType } from 'src/utils/types';
import { SafeAnyType } from 'src/utils/safeAny';
import { getUniqueId } from 'src/utils/getUniqueId';
import { CheckoutConfirmationTableLayout } from 'src/pages/Checkout/components/common/TableLayout';

export type CheckoutConfirmationTableColumnType = { name: string; className?: string };
export type CheckoutConfirmationTableColumnsType = (false | CheckoutConfirmationTableColumnType)[];

type Props<D extends Record<SafeAnyType, SafeAnyType>[]> = {
  columns: CheckoutConfirmationTableColumnsType;
  data: D;
  children: (item: D[0]) => ChildrenPropType;

  customRow?: boolean;
};

// eslint-disable-next-line react/function-component-definition
export function CheckoutConfirmationTable<D extends Record<SafeAnyType, SafeAnyType>[]>({
  columns,
  data,
  children,
  customRow,
}: Props<D>) {
  const preparedData: { id: string }[] = useMemo(() => data.map((item) => ({ id: getUniqueId(), ...item })), [data]);

  const LineElement = customRow ? Fragment : 'tr';

  return (
    <CheckoutConfirmationTableLayout
      tHead={
        <tr>
          {(columns.filter(Boolean) as CheckoutConfirmationTableColumnType[]).map((item) => (
            <th key={`${item.name}${item.className}`} className={item.className}>
              {item.name}
            </th>
          ))}
        </tr>
      }
    >
      {preparedData.map(({ id, ...item }) => (
        <LineElement key={id}>{children(item)}</LineElement>
      ))}
    </CheckoutConfirmationTableLayout>
  );
}
